import axios from 'axios';

import baseURL from './apiBaseUrl';

const api = axios.create({
  baseURL,
  headers: { 'Content-Type': 'application/json' },
});

// Interceptor — הוספת Authorization
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// רענון אסימון — רענון אחד משותף לכל מי שמבקש בו-זמנית (interceptor / נגן אודיו)
let refreshPromise = null;

const refreshAccessToken = () => {
  if (!refreshPromise) {
    refreshPromise = (async () => {
      const refreshToken = localStorage.getItem('refreshToken');
      if (!refreshToken) throw new Error('אין refresh token');
      const { data } = await axios.post(`${baseURL}/auth/refresh`, { refreshToken });
      localStorage.setItem('accessToken', data.accessToken);
      localStorage.setItem('refreshToken', data.refreshToken);
      return data.accessToken;
    })().finally(() => { refreshPromise = null; });
  }
  return refreshPromise;
};

const tokenExpiresSoon = (token, marginSec = 60) => {
  try {
    const { exp } = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    return !exp || exp * 1000 < Date.now() + marginSec * 1000;
  } catch {
    return true;
  }
};

/**
 * כתובת מלאה למדיה עם ?t=<accessToken> — ל-<audio src> שלא שולח Authorization.
 * מרענן את האסימון מראש אם הוא עומד לפוג.
 */
export const mediaUrl = async (path) => {
  let token = localStorage.getItem('accessToken');
  if (!token || tokenExpiresSoon(token)) token = await refreshAccessToken();
  const sep = path.includes('?') ? '&' : '?';
  return `${baseURL}${path}${sep}t=${encodeURIComponent(token)}`;
};

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Login failures must reach the form with their original server message.
    if (!originalRequest || /\/auth\/(login|refresh)\/?$/.test(originalRequest.url || '')) {
      return Promise.reject(error);
    }

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const token = await refreshAccessToken();
        originalRequest.headers.Authorization = `Bearer ${token}`;
        return api(originalRequest);
      } catch (refreshError) {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default api;
